<template>
  <v-app>
    <Navbar v-if="$route.name!='Login'"/>
    <vtoast ref="vtoast"/>

    <v-main>

      <router-view> </router-view>
      
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Navbar from "@/components/Navbar.vue";
import vtoast from '@/components/vtoast.vue';

export default {
  name: "App",
  components: { Navbar , vtoast },

  data: () => ({
  }),

  // recuperar metodos de ./store/index.js
  methods: {
    ...mapActions(['recuperarSesion','actualizarFechaActividad']),
    ...mapGetters(['getHoraActual']),

  },
  onIdle() {
    
    this.recuperarSesion();
  },
  onActive() {
    this.recuperarSesion();
    this.actualizarFechaActividad();
  },

  created() {
    this.recuperarSesion();
  },

  mounted() {
    this.$root.vtoast = this.$refs.vtoast
  },


};
</script>

<style>
/* html{
  font-size: 14px;
} */

.v-main {
  background-color: #d1d1d1!important;
}

.colorP{
  background-color:rgb(0, 112, 177);
}

.colorP2{
  color: rgb(0, 112, 177);
}

.noBreak{
  word-break: normal!important;
}


@media screen and (min-width : 425px){
  .tamTexto *:not(i):not(button){
   font-size: 12px!important;
  }
}

.tamTexto1 *:not(i):not(button){
   font-size: 12px!important;
  }
</style>